<template>
    <v-dialog :persistent="true" max-width="1000px" v-model="dlg">
        <v-form data-vv-name="notesForm">
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">
                            Danh sách ghi chú
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                            @click="dlg=false"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <table class="lstTable">
                        <tr>
                            <th width="15%">Người gửi</th>
                            <th width="65%">Nội dung</th>
                            <th width="20%">Thời gian</th>
                        </tr>
                        <tr v-for="item in lstNote">
                            <td><label style="font-weight: bold;color:blue">{{item.userName}}</label></td>
                            <td><label v-if="item.content"> {{item.content}}</label></td>
                            <td>{{item.createdAt|formatDateTime}}</td>
                        </tr>
                        <tr v-if="lstNote.length == 0">
                            <td colspan="3">Không có ghi chú</td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-textarea :label="$t('lang.common.note')"
                                            v-model="item.content"
                                            v-validate="'max:500'"
                                            name="content"
                                            :data-vv-as="$t('lang.common.note')"
                                            :error-messages="errors.first('content')"
                                            append-icon="send"
                                            @click:append="onSave"
                                />
                            </td>
                        </tr>
                    </table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn @click="dlg=false">{{$t('lang.common.close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import {message} from "../../../../services";
    import axios from "axios";
    import CSearchForm from "../../../../components/form/ManageForm";

    export default {
        name: "request-note",
        components: {message, axios, CSearchForm},
        props: {
            objectId: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            objectType: {
                type: Boolean,
                default: false,
            },
        },
        data: () => {
            return {
                item: {
                },
                lstNote:[],
                inDialog: false,
                dlg:false,
            };
        },
        watch: {
            cDialog(value) {
                this.inDialog = value;
            },
            inDialog(value) {
                if (!value) {
                    this.$emit("closeDialog", "");
                }
            }
        },
        methods: {
            onCancel: function () {
                this.$emit("closeDialog");
                this.dlg = false;
            },
            onSave: function () {
                // this.onCancel();
                //
                axios.post(process.env.VUE_APP_API_URL+"/requestNote/save",this.item).then(
                    data=>{
                        if(data.success){
                            this.item.content = null;
                            this.loadContent();
                        } else {
                            message.error(data.description);
                        }

                    }
                )
            },

            onShow(objectId, objectType){
                this.dlg = true;
                this.item.content = null;
                this.item.objectId = objectId;
                this.item.objectType = objectType;
                this.loadContent();
            },

            loadContent(){
                axios.post(process.env.VUE_APP_API_URL+"/requestNote/search",this.item).then(
                    data=>{
                        this.lstNote = data.items;
                    }
                )
            },
        },
        created() {
        },
    };
</script>